<template>
  <!-- 项目列表【全部项目、我参与的项目】 author: zhangxiaofeng -->
  <div class="copyright_list" :data="$route.path">
    <div class="operate-box">
      <w-row type="flex" justify="space-between">
        <w-col class="tips-btn flex-1">
          <w-button size="small" type="primary" @click="uploadRecordedProject()" v-if="hasModuleAuth('zjy_module_project_baxm_manage')">
            上传备案项目
          </w-button>
          <!--<h2 class="copyright_title">电子备案库</h2>-->
        </w-col>
        <w-col class="tips-search-tag margin-right-10">
          <w-select size="small" v-model="queryParam.projectTag" @change="getProjectList">
            <w-option label="全部项目" value=""></w-option>
            <w-option v-for="(item, index) of stages" :label="item" :value="index+''"></w-option>
          </w-select>
        </w-col>
        <w-col class="tips-search">
          <w-input size="small" ref="userNameInput" style="width: 220px;" v-model="queryParam.searchKey" @input="search" placeholder="输入关键字搜索">
            <i slot="prefix" class="r2-icon-action_search" style="fontSize: 20px!important; lineHeight: 32px;"></i>
            <i
              v-if="queryParam.searchKey!=''"
              class="r2-icon-nav_cancel cursor-pointer"
              style="lineHeight: 32px;"
              slot="suffix"
              @click="queryParam.searchKey='';search('')">
            </i>
          </w-input>
        </w-col>
        <w-col class="tips-type">
          <i
            :class="['r2-icon-editor_format_list_bulleted icon-type-change cursor-pointer float_left', moduleType === 'list' ? 'active' : '']"
            @click="changeModuleType('list')" v-if="moduleType === 'thumbnail'"></i>
          <i
            :class="['r2-icon-device_widgets_outlined icon-type-change cursor-pointer float_left', moduleType === 'thumbnail' ? 'active' : '']"
            @click="changeModuleType('thumbnail')" v-if="moduleType === 'list'"></i>
        </w-col>
      </w-row>
    </div>
    <div class="table-box" id="table-box">
      <!-- 列表展示区域 -->
      <div v-if="moduleType==='list'" class="ui-fixed tree-table fit flex flex-column table-medium table-beyond-hiding" :style="{height:tableHeight-(pagination.total>0?50:0)+'px',marginBottom:'1em'}" id="tree-table" v-loading="loading">
        <div class="header-wrapper" ref="headerWrapper">
          <div class="table-header flex flex-row" style="width: 100%;">
            <div class="header-item is-leaf" style="width: 130px;">项目编号</div>
            <div class="header-item is-leaf flex-1">项目名称</div>
            <div class="header-item is-leaf" style="width: 120px;">项目标签</div>
            <div class="header-item is-leaf" style="width: 200px;">备案人</div>
            <div class="header-item is-leaf" style="width: 120px;">备案时间</div>
            <div class="header-item is-leaf is-operate" style="width: 80px;">操作</div>
            <div class="has-gutter" v-if="scrollY"></div>
          </div>
        </div>
        <div class="body-wrapper flex-1" style="overflow: auto;" ref="bodyWrapper">
          <ul class="container" style="width: 100%;" ref="containerWrapper">
            <li class="flex flex-row row row--level-1" :class="item.recordStatus==1?'row_disable':''" v-for="(item, index) in data" :key="index">
              <div class="cell column_1" style="width: 130px;">
                {{item.projectNumber}}
              </div>
              <div class="cell column_2 flex-1" @click="previewProject(item)">
                <div class="project-name cursor-pointer">
                  {{item.projectName}}
                  <!--<el-tooltip v-if="item.uploadResult === 2">-->
                    <!--<div slot="content">-->
                      <!--<div style="line-height: 28px;">上传失败，</div>-->
                      <!--<div style="line-height: 28px;"><a href="javascript: void(0)" @click.stop="uploadRecordedProject(item)">点击重新上传</a></div>-->
                    <!--</div>-->
                    <!--<i class="r2-icon-alert_error color-red" style="font-size: 20px;"></i>-->
                  <!--</el-tooltip>-->
                </div>
              </div>
              <div class="cell column_3" style="width: 120px;">
                {{stages[item.projectTag]}}
              </div>
              <div class="cell column_4" style="width: 200px;">
                {{item.recordUsername}}
              </div>
              <div class="cell column_4" style="width: 120px;">
                {{item.recordTime | formatDate}}
              </div>
              <div class="cell column_5 is-operate" style="width: 80px;">
                <template v-if="item.recordSource === 1">
                  <!--上传失败-->
                  <template v-if="item.uploadResult === 2">
                    <div class="width-full" v-if="item.managerId === userId">
                      <span class="cursor-pointer color-red" @click="uploadRecordedProject(item)">
                        重新上传
                      </span>
                    </div>
                    <div class="width-full" v-else>
                      <span class="not-allowed cursor-not-allowed color-red">
                        重新上传
                      </span>
                    </div>
                  </template>
                  <!--上传成功-->
                  <template v-else-if="item.uploadResult === 1">
                    <div style="width: 100%;" v-if="item.managerId!==userId&&!isAdmin">
                      <span class="not-allowed cursor-not-allowed" href="javascript:;">
                        设置权限
                      </span>
                    </div>
                    <div style="width: 100%;" v-else>
                      <span class="color-link cursor-pointer" href="javascript:;" @click="editName(item, $event)">
                        设置权限
                      </span>
                    </div>
                  </template>
                  <!--上传中-->
                  <template v-else>
                    <div style="width: 100%;">
                      <span class="not-allowed cursor-not-allowed">
                        设置权限
                      </span>
                    </div>
                  </template>
                </template>
                <template v-else>
                  <div style="width: 100%;" v-if="item.recordStatus==1">
                    <span href="javascript:;">
                      <w-progress :percentage="50" :format="format"></w-progress>
                    </span>
                  </div>
                  <div style="width: 100%;" v-else-if="item.managerId!==userId&&!isAdmin">
                    <span class="not-allowed cursor-not-allowed" href="javascript:;">
                      设置权限
                    </span>
                  </div>
                  <div style="width: 100%;" v-else>
                    <span class="color-link cursor-pointer" href="javascript:;" @click="editName(item, $event)">
                      设置权限
                    </span>
                  </div>
                </template>
              </div>
            </li>
          </ul>
        </div>
      </div>
      <!-- 缩略图展示区域 -->
      <div v-else class="thumbnail">
        <ul class="project-wrapper" v-loading="loading" :style="{height: tableHeight - (pagination.total > 0 ? 50 : 0) + 'px', overflow: 'auto'}">
          <li class="project-item" :class="item.recordStatus==1?'':'cursor-pointer'" v-for="(item, index) in data" :key="index">
            <div class="project-box" @click.stop="previewProject(item)" @contextmenu="contextmenu(item, $event)">
              <div class="project-pic relative">
                <div v-if="item.recordStatus!==1" class="absolute" style="right: 8px; top: 9px;z-index: 9;">
                  <template v-if="item.recordSource === 1">
                    <template v-if="item.uploadResult === 2">
                      <el-tooltip v-if="item.managerId === userId">
                        <div slot="content">
                          <div style="line-height: 28px;">上传失败</div>
                          <div style="line-height: 28px;">
                            <a style="color: #ffffff;text-decoration: underline;" href="javascript: void(0)" @click.stop="uploadRecordedProject(item)">
                              点击重新上传
                            </a>
                          </div>
                        </div>
                        <i class="r2-icon-alert_error color-red" style="font-size: 20px;" @click.stop=""></i>
                      </el-tooltip>
                    </template>
                    <template v-else-if="item.uploadResult === 1">
                      <w-dropdown @command="handlerAction" trigger="click">
                        <span class="w__dropdown-link" @click.stop="_clickHandle">
                           <span class="more"><i class="r2-icon-nav_more_vert" style="font-size: 20px !important;"></i></span>
                        </span>
                        <w-dropdown-menu :visibleArrow="false" slot="dropdown">
                          <w-dropdown-item :command="{item, type: 1, disable: item.managerId!==userId&&!isAdmin}" class="1" :class="{'not-allowed cursor-not-allowed': item.managerId!==userId&&!isAdmin}">设置权限</w-dropdown-item>
                        </w-dropdown-menu>
                      </w-dropdown>
                    </template>
                  </template>
                  <w-dropdown @command="handlerAction" trigger="click" v-else>
                    <span class="w__dropdown-link" @click.stop="_clickHandle">
                       <span class="more"><i class="r2-icon-nav_more_vert" style="font-size: 20px !important;"></i></span>
                    </span>
                    <w-dropdown-menu :visibleArrow="false" slot="dropdown">
                      <w-dropdown-item :command="{item, type: 1, disable: item.managerId!==userId&&!isAdmin}" class="1" :class="{'not-allowed cursor-not-allowed': item.managerId!==userId&&!isAdmin}">设置权限</w-dropdown-item>
                    </w-dropdown-menu>
                  </w-dropdown>
                </div>
                <img src="@/assets/images/building.png" width="212px" height="144px" alt="">
              </div>
              <div class="project-info relative">
                <div class="project-name ellipsis">
                  <span :title="item.projectName">{{item.projectName}}</span>
                </div>
                <div class="project-other-info">
                  <div class="name">备案人</div>
                  <div class="text ellipsis">{{item.recordUsername}}</div>
                </div>
                <div class="project-other-info">
                  <div class="name">项目标签</div>
                  <div class="text ellipsis">{{stages[item.projectTag]}}</div>
                </div>
                <div class="project-other-info">
                  <div class="name">备案时间</div>
                  <div class="text ellipsis">{{item.recordTime | formatDate}}</div>
                </div>
              </div>
            </div>
          </li>
          <template v-if="data.length === 0">
            <li class="project-item">
              <div class="project-box empty">
                <div class="tips">暂无数据</div>
                <div class="project-pic">
                  <img src="@/assets/images/building.png" width="212px" height="144px" alt="">
                </div>
                <div class="project-info relative"></div>
              </div>
            </li>
          </template>
        </ul>
        <context-menu :toggleShow="toggleShow" :position="position" :menuList="menuList" @menuClick="menuClick"></context-menu>
      </div>
      <w-pagination
        class="text-align-right"
        v-if="pagination.total>0"
        @current-change="handleCurrentChange"
        @size-change="handlePageSizeChange"
        :current-page.sync="queryParam.pageNum"
        background
        layout="total, prev, pager, next, jumper,sizes"
        :page-size="pagination.pageSize"
        :page-sizes="[50, 100]"
        :total="pagination.total">
      </w-pagination>
    </div>
    <w-dialog :boxStyle="{width: '720px', zIndex: '2001'}" :bodyStyle="{padding: '0px'}" :show="privilege.show" customClass="privilege-dialog" @close="privilege.show=false">
      <div slot="header">
        <span class="w__dialog--title">
          设置权限
          <!--备案项目成员-->
        </span>
      </div>
      <div style="padding: 10px 24px;">
        <w-button size="small" @click="setStatus(true)">可见</w-button>
        <w-button size="small" @click="setStatus(false)">不可见</w-button>
      </div>
      <div class="pri_content padding-0-24" v-loading="privilege.loading" element-loading-background="rgba(255,255,255,0.5)">
          <ul class="pri_header">
            <li class="pri_item pri_item_0">
              <w-checkbox :value="isCheckAll" @change="checkAll"></w-checkbox>
            </li>
            <li class="pri_item pri_item_1">员工姓名</li>
            <li class="pri_item pri_item_2">员工账号</li>
            <li class="pri_item pri_item_3">权限</li>
          </ul>
          <div class="pri_body list-wrap relative" ref="listWrap" @scroll="scrollListener">
            <div class="scroll-bar" ref="scrollBar" :style="{height: contentHeight + 'px'}"></div>
            <div ref="list" class="list-view-phantom">
              <ul class="pri_tr" v-for="(item, index) of showList" :key="item.memberId" :style="{ height: itemHeight + 'px' }">
                <li class="pri_item pri_item_0">
                  <template v-if="(+item.userRole === 2 || +item.roleId === 1) || +item.roleType === 2 || item.isProjectManager"></template>
                  <template v-else>
                    <w-checkbox :value="item.checked" @change="checkMember(index, item)"></w-checkbox>
                  </template>
                </li>
                <li class="pri_item pri_item_1 ellipsis">{{item.userName}}</li>
                <li class="pri_item pri_item_2 ellipsis">{{item.account}}</li>
                <li class="pri_item pri_item_4">
                  <template v-if="(+item.userRole === 2 || +item.roleId === 1) || +item.roleType === 2 || item.isProjectManager">
                    <w-radio disabled :label="true">可见</w-radio>
                  </template>
                  <template v-else>
                    <!--<w-radio-group v-model="item.visible">-->
                      <!--<w-radio :label="true">可见</w-radio>-->
                      <!--<w-radio :label="false">不可见</w-radio>-->
                    <!--</w-radio-group>-->
                    <w-radio-group :value="item.visible" @change="changeStatus(index, item)">
                      <w-radio :label="true">可见</w-radio>
                      <w-radio :label="false">不可见</w-radio>
                    </w-radio-group>
                  </template>
                </li>
              </ul>
            </div>
            <div v-if="privilege.data.length==0" style="color: #999;line-height: 50px;" class="text-align-center">
              暂无数据
            </div>
          </div>
          <div class="pri_foot">
            <w-button type="primary" @click="confirmPri">确定</w-button>
            <w-button type="minor" @click="privilege.show=false">取消</w-button>
          </div>
        </div>
    </w-dialog>
    <!-- 上传本地备案项目弹窗 -->
    <upload-project v-if="showUploadProjectDialog" :project-name="projectName" @close="cancelUploadProjectDialog"></upload-project>
  </div>
</template>
<style lang="less" type="text/less" scoped>
  .tree-table .body-wrapper ul li>div.cell{
    font-size: 14px;
    height: 56px;
  }
  .tree-table .header-wrapper .table-header>.header-item{
    background-color: #f3f4f7;
    color: rgba(32, 37, 48, .8);
  }
  .project-name{
    width: 100%;
    display: inline-block;
    &:hover{
      color: #2079fa;
    }
  }
  .not-allowed {
    color: #2125304f;
    &:hover {
      color: #2125304f;
    }
  }
  .copyright_list {
    width: 100%;
    height: 100%;
    padding: 24px;
    box-sizing: border-box;
    .copyright_title{
      line-height: 32px;
      font-size: 18px;
      font-weight:500;
      color:rgba(33,37,48,1);
      margin: 0;
    }
    .operate-box {
      height: 52px;
    }

    .table-box {
      height: calc(100% - 52px);
    }
    .tips-search-tag{
      width: 140px;
    }
    .tips-search {
      width: 220px;
    }

    .tips-type {
      width: 40px;

      i {
        width: 40px;
        padding: 2px;
        text-align: center;
        box-sizing: border-box;
        display: inline-block;

        &:hover {
          color: #2079FA;
        }
      }
    }
    tr:not(.row_disable) .editable-cell {
      cursor: pointer;

      &:hover {
        color: #2079fa;
      }
    }


    .operation {
      color: rgba(33,37,48,0.55);;
      cursor: pointer;
      padding: 0 4px;

      &:hover {
        color: #2079fa;
      }
    }

    .not-allowed {
      color: #2125304f;
      &:hover {
        color: #2125304f;
      }
    }

    .project-wrapper {

      .project-item {
        width: 210px;
        height: 262px;
        display: inline-block;
        margin-bottom: 24px;
        margin-right: 19px;
        box-sizing: border-box;
        -webkit-user-select: none;
        -moz-user-select: none;
        -ms-user-select: none;

        &:hover {
          .project-box:not(.empty) {
            box-shadow: 0 4px 12px rgba(0, 0, 0, .15);
          }
        }

        &:last-child {
          margin-right: 0;
        }

        .project-box {
          border-radius: 4px;
          overflow: hidden;
          position: relative;
          transition: all .3s cubic-bezier(.645, .045, .355, 1);

          &:not(.empty) {
            box-shadow:0px 2px 8px 0px rgba(33,37,48,0.15);
          }
          &:not(.empty):hover {
            box-shadow:0px 4px 16px 0px rgba(33,37,48,0.15);
          }

          .tips {
            position: absolute;
            left: 0;
            right: 0;
            top: 0;
            bottom: 0;
            z-index: 9;
            background: #ffffff;
            color: #ccc;
            border: 1px dashed #eee;
            display: flex;
            align-items: center;
            justify-content: center;
          }

          .project-pic {
            background: #eeeeee;
            width: 212px;
            height: 144px;
            position: relative;
            .more {
              display: none;
              color: #2079FA;
            }
            &:hover {
              .more {
                display: block;
              }
            }
          }

          .project-info {
            height: 118px;
            padding: 0 16px;
            background: #fff;

            .project-name {
              margin-top: 6px;
              font-size: 14px;
              font-weight: 700;
              color: rgba(33, 37, 48, 1);
              line-height: 32px;
              &:focus, &:hover, &:visited {
                outline: none;
              }
            }

            .project-other-info {
              height: 24px;
              font-size: 12px;
              font-weight: 400;
              color: rgba(33, 37, 48, 0.55);
              line-height: 24px;
              width: 100%;
              .name {
                width: 70px;
                display: inline-block;
                overflow: hidden;
              }
              .text {
                width: calc(100% - 70px);
                display: inline-block;
                text-align: right;
              }
            }
          }
        }
      }
    }
  }
  .pri_content{
    height: 430px;
    .pri_header{
      height: 40px;
      line-height: 40px;
      background:rgba(243,244,247,1);
      box-shadow:0px 1px 0px 0px rgba(33,37,48,0.15);
      margin: 0;
      .pri_item {
        height: 40px;
      }
    }
    .pri_body{
      width: 100%;
      height: 315px;
      overflow: auto;
      .pri_item {
        height: 56px;
      }
      .pri_tr{
        height: 56px;
        line-height: 56px;
        box-shadow:0px 1px 0px 0px rgba(33,37,48,0.1);
        margin: 0;
        &:hover {
          background-color: #f3f4f7;
        }
      }
      .pri_item_4{
        width: 224px;
      }
    }
    .pri_foot{
      text-align: right;
      margin-right: 24px;
      margin-top: 23px;
    }
    .pri_item{
      display: inline-block;
      overflow: hidden;
      /*float: left;*/
      box-sizing: border-box;
      padding: 0 16px;
      /*height: 56px;*/
      &:last-child {
        padding-right: 0;
      }
    }
    .pri_item_0{
      padding: 0 5px;
      width: 28px;
    }
    .pri_item_1{
      width: 140px;
    }
    .pri_item_2{
      width: 260px;
    }
    .pri_item_3{
      width: 224px;
    }

    .list-view-phantom {
      position: absolute;
      left: 0;
      top: 0;
      right: 0;
      z-index: 0;
    }

    .list-view-content {
      left: 0;
      right: 0;
      top: 0;
      position: relative;
    }
  }
  .pri-title {
    width: 450px;
    padding: 0 10px;
    line-height: 44px;
    span {
      display: inline-block;
      &:nth-child(1) {
        text-align: left;
        font-size: 12px;
        width: 120px;
      }
      &:nth-child(2) {
        width: 80px;
        text-align: center;
        color: #fff;
      }
      &:nth-child(3) {
        width: 80px;
        text-align: center;
        color: #fff;
      }
      &:nth-child(4) {
        width: 80px;
        text-align: center;
        color: #fff;
      }
      &:nth-child(5) {
        width: 80px;
        text-align: center;
        color: #fff;
      }
    }
  }
  .pri-cnt {
    padding: 0 10px;
    width: 460px;
    box-sizing: border-box;
    span {
      display: inline-block;
      line-height: 32px;
      &:nth-child(1) {
        text-align: left;
        font-size: 12px;
        width: 120px;
      }
      &:nth-child(2) {
        width: 80px;
        text-align: center;
        color: #00c461;
        &.disable {
          color: #6f7175;
        }
      }
      &:nth-child(3) {
        width: 80px;
        text-align: center;
        color: #00c461;
        &.disable {
          color: #6f7175;
        }
      }
      &:nth-child(4) {
        width: 80px;
        text-align: center;
        color: #00c461;
        &.disable {
          color: #6f7175;
        }
      }
      &:nth-child(5) {
        width: 80px;
        text-align: center;
        color: #00c461;
        &.disable {
          color: #6f7175;
        }
      }
    }
  }
  // .ant-table-tbody > tr:hover:not(.ant-table-expanded-row):not(.ant-table-row-selected) > td
</style>
<style lang="less">
body{
  .ant-table-tbody
  > tr:hover:not(.ant-table-expanded-row):not(.ant-table-row-selected)
  > td {
    background: rgba(243, 244, 247, 1);
  }
  .privilege-dialog{
    width: 630px;
    .w__dialog--header{
      padding: 0;
      height: 56px;
      padding-left: 24px;
      line-height: 56px;
      border-bottom: none;
    }
    .w__dialog--body{
      padding: 0;
    }
  }
}
</style>
<script>
import _ from 'lodash'
import {getCookie} from '@/assets/utils/CommonUtil'
import {on, off} from '@/assets/utils/index'
import r2Project from '@/assets/service/r2Project'
import spaceService from '@/assets/service/space'
import {formatDate} from '@/assets/utils/Date'
import contextMenu from '@/components/common/contextMenu/Index'
import UploadProject from './UploadProject'
import {mapMutations} from 'vuex'
import Bus from '@/assets/utils/bus'
import websocketMixin from '@/assets/mixins/websocket'

// 阶段
const stages = [
  '未中标项目',
  '中标项目',
  '结算项目',
  '评估项目'
]
// let isAdmin
export default {
  name: 'DatabaseRecord',
  mixins: [websocketMixin],
  components: {
    contextMenu,
    UploadProject
  },
  data () {
    return {
      scrollY: false,
      loading: false,
      moduleType: 'thumbnail', // list
      deleteItem: null, // 正在执行删除操作的 行数据
      page: this.$route.path.indexOf('/all/') > -1,
      data: [], // 项目列表
      renameObj: {},
      stages,
      tag: '',
      pagination: {
        total: 0,
        pageSize: 50,
        defaultPageSize: 50,
        pageSizeOptions: ['50', '100'],
        showSizeChanger: true,
        showQuickJumper: true
      },
      queryParam: {
        // 查询参数
        pageNum: 1, // 第几页
        pageSize: 50, // 每页中显示数据的条数
        searchKey: '',
        projectTag: ''
      },
      currentRow: {},
      position: {
        left: 0,
        top: 0,
        bottom: 0
      },
      menuList: [
        {name: '设置权限', type: 1, disabled: false}
      ],
      toggleShow: false,
      isAdmin: false,
      userId: getCookie('gldUserId'),
      privilege: {
        data: [], // 总数据
        totalOptional: 0,
        loading: false,
        show: false
      },
      allMembers: [],
      isCheckAll: false,
      showUploadProjectDialog: false,
      projectName: '',
      files: [],
      itemHeight: 56, // 每一列的高度
      showNum: 10, // 显示几条数据
      start: 0, // 滚动过程显示的开始索引
      end: 10 // 滚动过程显示的结束索引
    }
  },
  computed: {
    contentHeight () {
      // 计算滚动条高度
      return this.privilege.data.length * this.itemHeight
    },
    // 显示的数组，用计算属性计算
    showList (){
      return this.privilege.data.slice(this.start, this.end)
    }
  },
  watch: {
    'queryParam.search': function () {
    },
    'queryParam.time': function () {
      if (this.queryParam.time) {
        this.queryParam.year = this.queryParam.time.getFullYear()
      } else {
        this.queryParam.year = ''
      }
    },
    'queryParam.year': function () {
      this.search()
    },
    isCheckAll () {

    }
  },
  filters: {
    roleFilter: function (role) {
      if (role === 1 || this.isAdmin) {
        return '项目管理'
      } else if (role === 2) {
        return '项目编辑'
      } else {
        return ''
      }
    },
    formatDate (time) {
      var date = new Date(time)
      return formatDate(date, 'yyyy-MM-dd')
    }
  },
  updated () {
    let scrollY
    try {
      scrollY = this.$refs.containerWrapper.clientHeight > this.$refs.bodyWrapper.clientHeight
    } catch (e) {
      scrollY = false
    }
    this.scrollY = scrollY
  },
  created () {
    this.isAdmin = this.hasPermissonList('zjy_module_project_baxm_manage')
  },
  beforeDestroy () {
    off(window, 'click', this._clickHandle)
    this._clickHandle = null
  },
  mounted () {
    this.sentLog(100115001)
    this.sentLog(100115002)
    on(window, 'click', this._clickHandle)
    this.init()
    let userinfo = getCookie('ZJYUSERINFO')
    if (userinfo) {
      userinfo = JSON.parse(userinfo)
      this.user = userinfo
    }
    // const otherHeight = 280;
    // this.setTableHeight(otherHeight);
    // // 窗口大小改变时 触发
    // this.resizeHandle.resize(() => {
    //   this.setTableHeight(otherHeight);
    // });
    setTimeout(() => {
      this.tableHeight = this.getTableHeight('table-box')
    })
    // 窗口大小改变时 触发
    this.resizeHandle.resize(() => {
      this.tableHeight = this.getTableHeight('table-box')
    })
  },
  methods: {
    ...mapMutations({
      setPath: 'project/SET_PATH'
    }),
    // 关闭右键菜单
    _clickHandle () {
      this.toggleShow = false
    },
    // 切换类型
    changeModuleType (type = 'list') {
      this.moduleType = type
    },
    // 1.1 初始化
    init () {
      this.getProjectList()
    },
    // 1.2 获取项目列表
    getProjectList () {
      let api = 'getRecordedList'
      if (this.queryParam.projectTag !== '' || this.queryParam.searchKey !== ''){
        api = 'getSearchRecordedList'
      }
      this.loading = true
      this.data = []
      r2Project[api](this.queryParam).then(res => {
        this.loading = false
        if (+res.code === 200) {
          this.data = res.data.items || []
          const pagination = {...this.pagination}
          pagination.total = res.data.totalCount || 0
          this.pagination = pagination
        } else {
          this.$message({
            type: 'error',
            message: res.message ? res.message : '请求列表失败！'
          })
        }
      }).catch(() => {
        this.$message.error('请求列表失败！')
        // this.$loading.hide()
      })
    },
    handleCurrentChange (index) {
      this.pagination.current = index
      this.queryParam.pageNum = index
      this.getProjectList()
    },
    handlePageSizeChange (index) {
      this.pagination.pageSize = index
      this.queryParam.pageSize = index
      this.pagination.current = 1
      this.queryParam.pageNum = 1
      this.getProjectList()
    },
    // 1.4 调用查询接口为dataSource 赋值
    getTableList () {
      this.loading = true
      retriveHosData(this.queryParam).then(res => {
        if (res.message === 'SUCCESS') {
          const pagination = {...this.pagination}
          pagination.total = res.data.total
          this.tableDatas = res.data.list
          this.pagination = pagination
        }
        this.loading = false
      })
    },
    // 更新虚拟占位的高度
    scrollListener (){
      // 获取滚动高度
      let scrollTop = this.$refs.listWrap.scrollTop
      // 开始的数组索引
      this.start = Math.floor(scrollTop / this.itemHeight)
      // 结束索引
      this.end = this.start + this.showNum
      // 绝对定位对相对定位的偏移量
      this.$refs.list.style.top = this.start * this.itemHeight + 'px'
    },
    // 计算角色权限
    calcMemberPermission (data) {
      let administrators = []
      let projectAdministrators = []
      let memberData = []
      data.forEach(item => {
        if (item.status !== 1) {
          if (item.gldUserId && item.memberId === undefined) {
            item.memberId = item.gldUserId
          }
          let visible = !!(+item.roleType === 2 || (item.roleType === undefined && !(+item.userRole !== 2 && +item.roleId === 3)))
          item.visible = visible
          item.oldVisible = visible
          if (+item.userRole === 2 || +item.roleType === 2) {
            administrators.push(item)
          } else if (+item.roleId === 1) {
            projectAdministrators.push(item)
          } else {
            item.checked = false
            memberData.push(item)
          }
        }
      })
      return [administrators.concat(projectAdministrators).concat(memberData), memberData.length]
    },
    // 1.5 权限设置
    editName (data) {
      const errMsg = '获取备案项目人员列表失败！'
      this.sentLog(100115003)
      this.privilege.show = true
      this.privilege.loading = true
      this.privilege.data = []
      this.privilege.projectId = data.projectId
      this.$refs.list.style.top = '0px'
      this.start = 0 // 滚动过程显示的开始索引
      this.end = 10 // 滚动过程显示的结束索引
      this.isCheckAll = false
      Promise.all([spaceService.getUserList(), r2Project.getRecordedMembersList({id: data.projectId})]).then(raw => {
        this.privilege.loading = false
        const [total, member] = raw
        if (total.code === 200 && member.code === 200) {
          const alreadyMembers = member.data || []
          const memberIds = alreadyMembers.map(item => item.memberId)
          const allMembers = total.data || []
          this.allMembers = allMembers
          const [privilegeData, totalOptional] = this.calcMemberPermission(alreadyMembers.concat(allMembers.filter(item => !memberIds.includes(item.gldUserId))))
          this.privilege.data = privilegeData
          this.privilege.totalOptional = totalOptional
        } else {
          this.$message.error(errMsg)
        }
      }).catch(() => {
        this.privilege.loading = false
        this.$message.error(errMsg)
      })
      // r2Project.getRecordedMembersList({id: data.projectId}).then((res) => {
      //   this.privilege.loading = false
      //   if (+res.code === 200) {
      //     let index, memberData
      //     memberData = res.data.map((item, i) => {
      //       let visible = !(item.userRole !== 2 && item.roleId === 3)
      //       if (+item.userRole === 2) {
      //         index = i
      //       }
      //       return Object.assign({visible: visible, oldVisible: visible}, item)
      //     })
      //     if (index) {
      //       let manager = memberData.splice(index, 1)
      //       memberData.unshift(manager[0])
      //     }
      //     this.privilege.data = memberData
      //   } else {
      //     this.$message.error(res.message ? res.message : '获取备案项目人员列表失败！')
      //   }
      // }).catch(() => {
      //   this.privilege.loading = false
      //   this.$message.error('获取备案项目人员列表失败！')
      // })
    },
    // 1.7 权限设置
    // renameServer
    confirmPri () {
      const data = [...this.privilege.data]
      let changedData = data.filter((item) => item.visible !== item.oldVisible)
      let params = changedData.map(item => ({memberId: item.memberId, visible: item.visible}))
      if (params.length === 0) {
        this.privilege.show = false
        return
      }
      const loading = this.$loading({
        background: 'rgba(0, 0, 0, 0.3)'
      })
      r2Project.setRecordedMembersPrivilege(params, {id: this.privilege.projectId}).then(data => {
        loading.close()
        this.privilege.show = false
        if (+data.code === 200) {
          this.$message.success('权限设置成功！')
        } else {
          this.$message.error('权限设置失败！')
        }
      }).catch(() => {
        loading.close()
        this.privilege.show = false
        this.$message.error('权限设置失败！')
      })
    },
    // 查看项目详情
    previewProject ({projectId, projectName, recordStatus, editable}) {
      this.sentLog(100115004)
      this.setPath(this.$route.path)
      this.$router.push({path: `/database/data/record/${projectId}/files/全部文件`, query: {projectName}})
      // gotoDetail({}) {
      //   if (this.disabled) {
      //     return
      //   }
      //   this.setPath(this.$route.path)
      //   this.$router.push({path: `${this.id}/files/全部文件`, query: {prjName: this.text}})
      // }
    },
    // 右键菜单
    contextmenu (item, event) {
      // 阻止默认右键点击事件
      if (event.preventDefault) {
        event.preventDefault()
      } else {
        event.returnValue = false
      }
      this.currentRow = item
      if (+item.recordStatus === 1) {
        return
      }
      if (item.managerId !== this.userId && !this.isAdmin) {
        this.menuList.map(item => {
          item.disabled = true
        })
      } else {
        this.menuList.map(item => {
          item.disabled = false
        })
      }
      // 获取右键坐标
      let maxWidth = document.body.clientWidth
      let maxHeight = document.body.clientHeight
      if (maxHeight - event.clientY < 100) {
        this.position.top = 0
        this.position.bottom = (maxHeight - event.clientY)
      } else {
        this.position.top = event.clientY
        this.position.bottom = 0
      }
      if (maxWidth - event.clientX < 100) {
        this.position.left = 0
        this.position.right = (maxWidth - event.clientX)
      } else {
        this.position.left = event.clientX
        this.position.right = 0
      }
      // 菜单出现的flag
      this.toggleShow = true
      // 显示弹出窗
    },
    handlerAction ({item, type, disable}) {
      if (disable) {
        return
      }
      this.currentRow = item
      this.menuClick({type})
    },
    // 右键菜单点击
    menuClick ({type}, item = {}) {
      this.toggleShow = false
      // let {prjId, prjName} = this.currentRow
      if (type === 1) {
        this.editName(this.currentRow)
      } else if (type === 2) {
        this.$confirm({
          message: '确定删除该项目？',
          type: 'warning',
          width: 400,
          submit: () => {
            // this.onDelete(prjId, prjName);
          }
        })
      }
      this.key = Date.now()
    },
    // 2.2 搜索
    search: _.debounce(function (data) {
      this.getProjectList()
    }, 800),
    // 2.3 创建
    goAdd () {
      this.setPath(this.$route.path)
      this.$router.push({name: 'prjAdd'})
    },
    // 2.4 备案进度显示
    format (percentage) {
      return '备案中'
    },
    // 创建备案项目/备案项目重新上传
    uploadRecordedProject (item) {
      const params = {
        type: 'folder',
        parameter: {
          filePath: '',
          workspaceId: getCookie('enterpriseWorkspaceIdValue')
        },
        singleFileNoticeFn: this.singleFileNoticeFn,
        uploadResultNoticeFn: this.uploadResultNoticeFn,
        maximum: 0,
        fileSize: 5 * 1024 * 1024 * 1024, // 单文件大小5G
        fileSizeAlertMessage: '单个文件不能超过5G，请您选择小于5G的文件上传',
        nowPage: 'record',
        moduleName: '备案项目',
        headers: {
          Authorization: `Bearer ${getCookie('gldToken')}`
        },
        isDataModule: false,
        needRecord: false
      }
      if (item) {
        const {projectId, projectNumber, projectName, projectTag, permissionType, description} = item
        this.sentLog(100112066, {projectId, projectNumber, projectName, projectTag, permissionType, description})
        r2Project.getRecordedUploadUrl().then(res => {
          const {code, data} = res
          const { uploadUrl: outerChainBaseUrl, recordWorkspaceId: workspaceId } = data || {}
          if (code === 200 && outerChainBaseUrl && workspaceId) {
            Bus.$emit('uploadProject', Object.assign(params, {
              projectName,
              outerChainBaseUrl,
              againUpload: true,
              afterSelectFn: files => {
                const folderName = files[0].name.split('/')[0]
                if (folderName !== projectName) {
                  this.$confirm({
                    message: '您选择的文件夹名称和原项目名称不一致，是否将所选文件夹内容全部上传到原项目中？',
                    width: 420,
                    noCancelBtn: false,
                    bodyStyle: {},
                    footerStyle: {},
                    submit: () => {
                      this.recordedProjectAgainUpload({projectId, projectNumber, projectName, outerChainBaseUrl, workspaceId, files})
                    },
                    cancel () {
                      Bus.$emit('removeFiles', {files})
                    },
                    submitText: '继续上传',
                    cancelText: '取消'
                  })
                } else {
                  this.recordedProjectAgainUpload({projectId, projectNumber, projectName, outerChainBaseUrl, workspaceId, files})
                }
              }
            }))
          } else {
            this.$message.error('获取上传地址失败，请稍后重试')
          }
        })
      } else {
        this.sentLog(100112061)
        Bus.$emit('uploadProject', Object.assign(params, {
          projectName: '',
          outerChainBaseUrl: '',
          againUpload: false,
          afterSelectFn: files => {
            this.files = files
            const folderName = files[0].name.split('/')[0]
            this.projectName = folderName
            this.showUploadProjectDialog = true
          }
        }))
      }
    },
    // 备案项目重新上传
    recordedProjectAgainUpload ({projectId, projectNumber, projectName, outerChainBaseUrl, workspaceId, files}) {
      // 更新项目状态
      r2Project.updateProjectStatus({projectId})
      // 创建一个新的链接
      this.connectionUpload({projectId, projectNumber, projectName})
      Bus.$emit('againUploadFiles', {
        files,
        active: true,
        projectId,
        projectName,
        outerChainBaseUrl,
        uploadResultNoticeFn: ({projectId, projectName, result}) => {
          // 发送上传结果
          r2Project.uploadResultNotice({ projectId, projectName, result }).then(res => {
            // 断开socket链接
            this.disconnectUpload(projectId)
          })
          this.search()
        },
        workspaceId // 传备案库空间ID，为了保证文件上传空间位置的正确性
      })
    },
    // 单文件上传结果通知
    singleFileNoticeFn ({workspaceId, fileId, result = false, projectId, projectName}) {
      if (result) {
        r2Project.singleFileNotice({ workspaceId, fileId, folder: false })
      } else {
        //
      }
    },
    // 备案项目上传结果通知
    uploadResultNoticeFn ({projectId, projectName, result}) {
      // 发送上传结果
      r2Project.uploadResultNotice({ projectId, projectName, result }).then(res => {
        // 断开socket链接
        this.disconnectUpload(projectId)
      })
      this.search()
    },
    // 关闭上传备案项目弹窗
    cancelUploadProjectDialog (success = false, data = {}) {
      this.showUploadProjectDialog = false
      if (success) {
        const {projectNumber, projectId, projectName, projectTag, permissionType, uploadUrl, description, recordWorkspaceId} = data
        this.connectionUpload({projectId, projectNumber, projectName}) // 创建一个新的链接
        this.sentLog(100112062, {
          code: projectNumber,
          name: projectName,
          flag: projectTag,
          permission: permissionType,
          message: description
        })
        Bus.$emit('updateFiles', {files: this.files, active: true, projectId, projectName, outerChainBaseUrl: uploadUrl, workspaceId: recordWorkspaceId})
      } else {
        this.sentLog(100112063)
        Bus.$emit('removeFiles', {files: this.files})
      }
    },
    // 全选/取消全选
    checkAll (checked) {
      this.privilege.data.forEach(item => {
        if (typeof item.checked === 'boolean') {
          item.checked = checked
        }
      })
      this.isCheckAll = checked
    },
    // 选择成员
    checkMember (index, item) {
      this.$set(this.privilege.data, (this.start + index), Object.assign(item, {checked: !item.checked}))
      // item.checked = !item.checked
      // this.privilege.data[this.start + index].checked = !this.privilege.data[this.start + index].checked
      const checkedOptional = this.privilege.data.filter(item => item.checked)
      this.isCheckAll = (checkedOptional && checkedOptional.length === this.privilege.totalOptional)
    },
    // 设置权限可见不可见
    changeStatus (index, item) {
      this.$set(this.privilege.data, (this.start + index), Object.assign(item, {visible: !item.visible}))
    },
    // 批量设置可见不可见
    setStatus (visible) {
      this.privilege.data.forEach((item, index) => {
        if (item.checked) {
          this.$set(this.privilege.data, index, Object.assign(item, {checked: false, visible}))
          // item.visible = visible
          // item.checked = false
        }
      })
      this.isCheckAll = false
    }
  }
}
</script>

